import * as React from 'react';
import { render } from 'react-dom';
import staticFooterLinks from '../../static/footer-links.json';
import createEmotionCache from '../../emotion-cache';
import { MaterialHeader } from '../../components/material-header';
import { MaterialFooter } from '../../components/material-footer';
import { getSearchResults } from '@cv/core-ui';

const cache = createEmotionCache();

const headerRoot = document.getElementById('header_root');
const footerRoot = document.getElementById('footer_root');
const settings = ((window as any).Drupal && (window as any).Drupal.settings) || {};
const cvContext = settings.cv_context || {};
const footerLinks = settings.footer_links || staticFooterLinks;
const navLinks = settings.nav_links || [];
const mainLinks = settings.main_links || [];
const userLinks = settings.user_links || [];
const helpLinks = settings.help_links || [];
const tripsEnabled = settings.trips_enabled || false;

const links = {
  nav: navLinks,
  main: mainLinks,
  user: userLinks,
  help: helpLinks,
  footer: footerLinks,
  search: '/search/site',
  searchApi: '/v1/cv_search',
  tripsApi: tripsEnabled ? '/trip-service/v1/trips' : undefined,
  login: '/travel-agent/login',
  logout: '/travel-agent/logout',
};

//Hydrate seems to sometime have issues, so just use render
if (headerRoot) {
  render(
    <MaterialHeader
      cache={cache}
      context={cvContext}
      links={links}
      addGlobal
      searchPlaceholder= {"Search hotels, tours, and destinations"}
      handleSearch={(search: string) =>
        getSearchResults(
          search,
          links.searchApi 
        )
      }
    />,
    headerRoot
  );
}

if (footerRoot) {
  render(<MaterialFooter cache={cache} context={cvContext} links={links} addGlobal={!headerRoot} />, footerRoot);
}
